// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  userId: __t.u64().name("user_id"),
  name: __t.option(__t.string()),
  online: __t.bool(),
  lastLogin: __t.timestamp().name("last_login"),
  lastLogout: __t.option(__t.timestamp()).name("last_logout"),
  createdAt: __t.timestamp().name("created_at"),
  isAdmin: __t.bool().name("is_admin"),
  isBanned: __t.bool().name("is_banned"),
  banStarted: __t.option(__t.timestamp()).name("ban_started"),
  banReason: __t.option(__t.string()).name("ban_reason"),
});
